import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Sift from "@/components/sift/Sift";
import ToolDialog from "@/components/management/tool/ToolDialog";
export default {
  name: "Tool",
  components: {
    Sift: Sift,
    ToolDialog: ToolDialog
  },
  props: [],
  data: function data() {
    return {
      baseUrl: process.env.BASE_URL,
      loading: false,
      siftData: [],
      list: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      prorData: null,
      selectObj: {
        data: []
      }
    };
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {
    this.fetchSiftData();
    this.getServeObj();
  },
  destroyed: function destroyed() {},
  methods: {
    // 搜索框组件数据
    fetchSiftData: function fetchSiftData() {
      var _this = this;

      this.loading = true;
      setTimeout(function () {
        _this.siftData = [{
          type: "text",
          key: "title",
          label: "工具名称",
          placeholder: "",
          default: ""
        }];
        _this.loading = false;

        _this.$nextTick(function () {
          _this.initPage();
        });
      }, 500);
    },
    // 获取查询列表
    getListFn: function getListFn() {
      var _this2 = this;

      var data = this.$qs.stringify({
        toolName: this.$refs.needSift.getValue().title,
        // 获取搜索条件的值
        pageNum: this.pageNum,
        pageSize: this.pageSize
      });
      this.$http.post("/tool/toolPageList", data).then(function (_ref) {
        var data = _ref.data;

        if (data.resCode === 0) {
          _this2.list = data.resData.list;
          _this2.total = data.resData.total;
        }

        _this2.loading = false;
      }).catch(function () {
        _this2.loading = false;
      });
    },
    // 添加
    addFn: function addFn() {
      this.$refs.toolDialog.dialogShow("", "");
    },
    // 删除
    deleteFn: function deleteFn(id, name) {
      var _this3 = this;

      this.$confirm("是否确定删除" + name + " ?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this3.loading = true; // 删除接口

        _this3.$http.get("/tool/toolDelete?toolId=" + id).then(function (_ref2) {
          var data = _ref2.data;

          if (data.resCode === 0) {
            _this3.$message.success(name + "删除成功!");

            _this3.getListFn();
          }

          _this3.loading = false;
        }).catch(function () {
          _this3.loading = false;
        });
      }).catch(function () {
        _this3.$message({
          type: "info",
          message: "已取消删除"
        });
      });
    },
    // 详情
    editFn: function editFn(id, name) {
      this.$refs.toolDialog.dialogShow(id, name);
    },
    // 服务对象
    getServeObj: function getServeObj() {
      var _this4 = this;

      this.$http.get("/hallServe/targetList").then(function (res) {
        res.data.resData.forEach(function (e) {
          _this4.selectObj.data.push({
            value: e.id + "",
            label: e.targetTypeName
          });
        });
      }).catch(function () {
        _this4.$message.error("网络错误，服务类型接口请求失败！");
      });
    },
    // 默认页面数据
    initPage: function initPage() {
      this.pageNum = 1;
      this.getListFn();
    },
    // 条数
    changeSize: function changeSize(value) {
      this.pageSize = value;
      this.getListFn();
    },
    // 上下页
    changePage: function changePage(value) {
      this.pageNum = value;
      this.getListFn();
    }
  },
  watch: {
    "selectObj.data": {
      handler: function handler(val, oldVal) {
        this.prorData = val;
      },
      immediate: true
    }
  },
  filters: {
    // 数组对象 转字符串 arr后台返回的数组
    filterToString: function filterToString(arr) {
      var backArr = [];
      eval("(" + arr + ")").forEach(function (e) {
        backArr.push(e.targetName);
      });
      return backArr.join("、");
    },
    toolUseFn: function toolUseFn(val) {
      var nub = val === 0 ? "默认" : val === 1 ? "信息公开" : "个人办公";
      return nub;
    }
  }
};